// import { Ability } from '@casl/ability'

// export const ability = new Ability()

// export const abilityPlugin = (store) => {
//   ability.update(store.state.rules)

//   return store.subscribe((mutation) => {
//     switch (mutation.type) {
//     case 'auth/authSuccess':      
//       ability.update(mutation.payload.rules)
//       break
//     case 'auth/logout':
//       ability.update([{ actions: 'read', subject: 'all' }])
//       break
//     }
//   })
// }

import { Ability } from '@casl/ability';

export const ability = new Ability();

export const abilityPlugin = (store) => {
  store.subscribe((mutation) => {
    switch (mutation.type) {
      case 'setRules':
        console.log('Updating ability with rules:', store.state.rules);
        ability.update(store.state.rules);
        break;
      case 'auth/authSuccess':
        console.log('Updating ability with rules:', mutation.payload.rules);
        ability.update(mutation.payload.rules);
        break;
      case 'auth/logout':
        ability.update([{ action: 'read', subject: 'all' }]);
        break;
    }
  });
};
